// Re-export alarm constants from main constants file
export {
  ALARM_CONTAINER_HEIGHT as CONTAINER_HEIGHT,
  ALARM_ROW_HEIGHT as ROW_HEIGHT,
  ALARM_HEADER_HEIGHT as HEADER_HEIGHT,
  ALARM_API_BATCH_SIZE as API_BATCH_SIZE,
  ALARM_SEVERITY_COLORS as SEVERITY_COLORS,
} from '../../../constants';
